module.exports = __webpack_public_path__ + "static/media/loading-preferred.557336d4.gif";